import React from "react";

const Page = ({ children, classes }) => {
  return (
    <div className="page">
      <div className={`h-100 flex-grow-1 d-flex flex-column px-3 ${classes}`}>
        {children}
      </div>
    </div>
  );
};

export default Page;
